module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "step-body weex-ct weex-div",
    attrs: {
      "weex-type": "div"
    }
  }, [_c('div', {
    ref: "wrapper",
    staticClass: "step-item-wrapper weex-ct weex-div",
    style: ([_vm._px2rem(_vm.rowStyles, 75)]),
    attrs: {
      "weex-type": "div"
    }
  }, [_c('div', {
    staticClass: "step-flow-wrapper weex-ct weex-div",
    attrs: {
      "weex-type": "div"
    }
  }, [_vm._l((_vm.formattedList), function(item, index) {
    return [(index < _vm.formattedList.length - 1) ? _c('div', {
      key: 'line' + index,
      staticClass: " weex-ct weex-div",
      class: ['step-line', _vm.showLine && 'hline'],
      style: (_vm._px2rem(Object.assign(item.lineStyles, _vm.linePos[index]), 75)),
      attrs: {
        "weex-type": "div"
      }
    }) : _vm._e()]
  })], 2), _vm._v(" "), _vm._l((_vm.formattedList), function(item, index) {
    return _c('div', {
      key: 'desc' + index,
      ref: 'item' + index,
      refInFor: true,
      staticClass: "step-item weex-ct weex-div",
      style: ([_vm._px2rem(item.columnStyles, 75)]),
      attrs: {
        "weex-type": "div"
      }
    }, [_c('div', {
      ref: 'point' + index,
      refInFor: true,
      staticClass: " weex-ct weex-div",
      class: ['step-point'],
      style: ([_vm._px2rem(item.pointStyles, 75)]),
      attrs: {
        "weex-type": "div"
      }
    }), _vm._v(" "), _c('p', {
      staticClass: " weex-el weex-text",
      class: ['step-desc'],
      style: ([_vm._processExclusiveStyle(item.descStyles, 75, 'text')]),
      attrs: {
        "weex-type": "text"
      }
    }, [_vm._v(_vm._s(item.desc))])])
  })], 2)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-c2751e36", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c2751e36","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/dof-step-flow-h/index.vue
// module id = 657
// module chunks = 0 1